import { render, staticRenderFns } from "./AttributeChildLotModal.vue?vue&type=template&id=4014fa5a"
import script from "./AttributeChildLotModal.vue?vue&type=script&lang=js"
export * from "./AttributeChildLotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports